























import Vue from 'vue'
import { Component, Prop } from "vue-property-decorator";

import { MessageButtons } from "../types";

@Component
export default class TelegramPostButtons extends Vue {
  @Prop() buttons!: MessageButtons
}
